import React, { useContext } from "react";
import { ProductContext } from "../../context";
import { CssH1, CssFormGroup, CssPopSection } from "./../uikit-b2c/uikit-b2c";
import { Button, Paper } from '../uikit-b2c/uikit-b2c';
import { MethodCard2 } from '../ps/MethodCard2';
import { MethodCVS } from '../ps/MethodPP';
import styled, { css, ThemeProvider } from "styled-components";
export const UserAccountPayment = () => {
  const valueFromContext = useContext(ProductContext);
  return (<React.Fragment>
    <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>
        <CssFormGroup indentation="lg">
          <CssH1>Saved payment methods</CssH1>
        </CssFormGroup>


        <CssFormGroup indentation='lg'>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            width: '100%',
            gridColumnGap: 44
          }}>

            <div className="">
              <MethodCard2 number='**** **** **** 8934' saved={true} icon='amex' />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button appearance="ghost">Edit</Button>&nbsp;&nbsp;&nbsp;
              <Button appearance="ghost">Delete</Button>
            </div>

          </div>
        </CssFormGroup>


        <CssFormGroup indentation='lg'>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            width: '100%',
            gridColumnGap: 44
          }}>

            <div className="">
              <MethodCard2 number='**** **** **** 8772' saved={true} icon='visa' />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button appearance="ghost">Edit</Button>&nbsp;&nbsp;&nbsp;
              <Button appearance="ghost">Delete</Button>
            </div>

          </div>
        </CssFormGroup>



        <CssFormGroup indentation='lg'>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            width: '100%',
            gridColumnGap: 44
          }}>

            <div className="">
              <MethodCVS email='mi***@gm***.com' saved={true} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button appearance="ghost">Edit</Button>&nbsp;&nbsp;&nbsp;
              <Button appearance="ghost">Delete</Button>
            </div>

          </div>
        </CssFormGroup>


        <CssFormGroup indentation='lg'>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            width: '100%',
            gridColumnGap: 44
          }}>

            <div className="">
            <CssAddMethod>
              <Icon>
                add_circle
              </Icon>
              {/* <br/> Add new saved payment method */}
            </CssAddMethod>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>

            </div>

          </div>
        </CssFormGroup>


      </CssPopSection>
    </CssFormGroup>
  </React.Fragment>);
};


const CssAddMethod = styled.div`
  display: flex;
  align-items:center;
  flex-direction:column;
  justify-content: center;
  min-height: 64px;
  /* font-size: 24px; */
  border: 1px dotted currentColor;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`
const Icon = styled.div`
  font-family: 'MaterialIcons';
  font-size: 24px;
`